import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { getQueryClient } from '@/lib/queryClient';
import { createComponentLogger } from '@/lib/logging/frontend-logger';
import { SpaBundleRevalidator } from '@/lib/spaBundleRevalidationComponent';

export function Providers({ children }: { children: React.ReactNode }) {
    const log = createComponentLogger('Providers');
    const [queryClient] = useState(() => getQueryClient());

    log.debug('QueryClientProvider is being rendered');

    return (
        <QueryClientProvider client={queryClient}>
            <SpaBundleRevalidator />
            {children}
        </QueryClientProvider>
    );
}
